module.exports = require('./readable').Transform



//////////////////
// WEBPACK FOOTER
// /home/travis/build/Pedro-vk/Bet-Token-wallet/node_modules/readable-stream/transform.js
// module id = EJO3
// module chunks = 0